{
    "raportakimhedefaylik": {
        "Baslik": "Team Target Maandverslag",
        "Yil": "Jaar",
        "Ay": "Maand",
        "Takim": "Team",
        "Detay": "Prestatiedetails",
        "Urun": "Product / Groep",
        "HedefAdet": "Doelaantal",
        "HedefTutar": "Doelbedrag",
        "GerceklesenAdet": "Gerealiseerd Aantal",
        "GerceklesenTutar": "Gerealiseerd Bedrag",
        "Kullanici": "Gebruiker",
        "Ara": "Zoeken",
        "Temizle": "Wissen"
    }
}
